export default __webpack_public_path__ + "static/media/broadBand.02634a8c.svg";